document.addEventListener('DOMContentLoaded', function () {
	const container = document.querySelector(
		'.block-navigation-country-selection'
	);
	if (!container) return;

	// Clone for mobile
	const navContainer = document.querySelector('.block-navigation__container');
	if (navContainer) {
		const mobileContainer = container.cloneNode(true);
		mobileContainer.classList.add(
			'block-navigation-country-selection--mobile'
		);
		navContainer.appendChild(mobileContainer);

		// Bind all events to the mobile clone
		bindCountrySelector(mobileContainer);
	}

	// Bind all events to the original
	bindCountrySelector(container);
});
const openThisEvent = new Event('navigation-search-opened');

// Extracted binding logic so it works on original and clone
function bindCountrySelector(container) {
	const openBtn = container.querySelector(
		'.block-navigation-country-selection__button'
	);
	const closeBtn = container.querySelector('.c-btn--close');
	const popup = container.querySelector(
		'.block-navigation-country-selection__form-popup'
	);
	const form = container.querySelector(
		'.block-navigation-country-selection__form'
	);

	// Toggle popup visibility
	openBtn?.addEventListener('click', function (e) {
		e.stopPropagation();
		popup.classList.toggle('is-open');
		window.dispatchEvent(openThisEvent);
	});

	// Close on close button
	closeBtn?.addEventListener('click', function () {
		popup.classList.remove('is-open');
	});

	// Click outside to close
	document.addEventListener('click', function (e) {
		if (!container.contains(e.target)) {
			popup.classList.remove('is-open');
		}
	});

	// Redirect on form submit
	form?.addEventListener('submit', function (e) {
		e.preventDefault();
		const langURL = form.querySelector('#language-select')?.value;

		if (langURL) {
			window.location = langURL;
		}
	});
}
